import { useNavigate } from 'react-router-dom'

export interface EditDocOption {
  fromIndexPage: boolean
}

function newKey() {
  return Date.now().toString()
}

const MAX_AGE = 7 * 24 * 60 * 60 * 1000 // a week
const POSS = 50 // once in 50 times
function garbageCollect() {
  if (Math.floor(Math.random() * POSS) !== POSS - 1) return
  const now = Date.now()
  const keys: string[] = []
  for (let i = 0; i < localStorage.length; i++) {
    keys.push(localStorage.key(i) || '0')
  }
  keys
    .filter((k) => k !== '0')
    .forEach((k) => {
      const t = parseInt(k) + MAX_AGE
      if (now > t && k) {
        localStorage.removeItem(k)
      }
    })
}

export default function useEditDocuments() {
  const navigate = useNavigate()

  const editDocuments = (
    mode: string,
    oIds: string[],
    fromIndexPage: boolean,
  ) => {
    garbageCollect()
    if (oIds.length > 1) {
      const k = newKey()
      localStorage.setItem(k, oIds.join(','))
      navigate(`/${mode}/document-detail?key=${k}`, {
        state: { fromIndexPage },
      })
    } else {
      navigate(`/${mode}/document-detail?id=${oIds[0]}`, {
        state: { fromIndexPage },
      })
    }
  }

  return editDocuments
}
